import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'

import App from './App.jsx'

createInertiaApp({
  title: (title) => title ? `${title} - MCloud.com` : 'MCloud.com',
  resolve: name => {
    const pages = import.meta.glob('./Pages/**/*.jsx', { eager: true })
    console.log("PAGE NAME", name)
    let page = pages[`./Pages/${name}.page.jsx`]
    
    // console.log("pageName", pageName, ">page: ", page, ">default", page.default, ">layout", page.default?.layout, ">DefaultLayout", page.default.layout ? ' yes' : 'no')
    page.default.layout = page.default.layout || ((page) => <App>{page}</App>)
    
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
